module.exports = __webpack_public_path__ + "static/media/ministry.7b77d1d6.png";